import moment from 'moment';

export default {
  data() {
    return {
      loader: false,
      totalCount: 0,
      currentPage: 1,
      perPage: 25,
      users: [],
      startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      searchUser: [],
      is_active: 'active',
      activeBtn: null,
      payload: {},
      reports: [],
      eventMode: 'all',
    };
  },
  computed: {
    filterUserOptions() {
      return this.sortedEmpIdUser(this.users);
    },

    eventModeOptions() {
      return [
        { value: 'all', label: 'All' },
        { value: 0, label: 'Entry' },
        { value: 1, label: 'Exit' },
      ];
    },

    tableFields() {
      return [
        { key: 'employee_id', label: 'Emp ID', sortable: true, thStyle: { width: '100px' } },
        { key: 'employee_name', label: 'Employee', sortable: true, thStyle: { width: '200px' } },
        { key: 'timestamp', label: 'Date & Time', sortable: true, thStyle: { width: '200px' } },
        { key: 'timestamp_utc', label: 'UTC Date & Time', sortable: true, thStyle: { width: '200px' } },
        { key: 'event_name', label: 'Event', sortable: true, thStyle: { width: '150px' } },
        { key: 'device', label: 'Device', sortable: true, thStyle: { width: '150px' } },
        { key: 'device_master', label: 'Master Device', sortable: true, thStyle: { width: '150px' } },
      ];
    },
  },
  watch: {
    currentPage(val) {
      if (val) this.getAclAccessLogs();
    },
    perPage() {
      if (this.currentPage === 1) {
        this.getAclAccessLogs();
      } else {
        this.currentPage = 1;
      }
    },
    is_active() {
      this.userList();
    },
  },

  mounted() {
    const queryParams = this.$route.query;

    if (queryParams && Object.keys(queryParams).length > 0) {
      if (queryParams.is_active) this.is_active = queryParams.is_active;
      if (queryParams.searchUser) {
        this.searchUser = queryParams.searchUser.split(',').filter(Boolean);
      }
      if (queryParams.eventMode !== undefined) {
        this.eventMode = queryParams.eventMode === '0' ? 0 : (queryParams.eventMode === '1' ? 1 : queryParams.eventMode);
      }
      
      this.startDate = queryParams.startDate || moment().subtract(7, 'days').format('YYYY-MM-DD');
      this.endDate = queryParams.endDate || moment().format('YYYY-MM-DD');
      
      if (queryParams.active) this.activeBtn = queryParams.active;
      if (queryParams.perPage) this.perPage = Number(queryParams.perPage);
      if (queryParams.currentPage) this.currentPage = Number(queryParams.currentPage);
    }

    this.getAclAccessLogs();
    this.userList();
  },

  methods: {
    async userList() {
      const input = {
        sort_field: 'name',
        sort_order: 'asc',
        include_system_users: 1,
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
      };
      const response = await this.getHTTPPostResponse(
        'admin/master/user/active-inactive-userlist',
        input,
        false,
      );
      if (response && response.data) {
        const { data } = response
        this.users = data.users
      }
    },
    updateDate(obj) {
      this.startDate = obj?.startDate || null;
      this.endDate = obj?.endDate || null;
      this.activeBtn = obj?.active || null;
      this.currentPage = 1;
      this.getAclAccessLogs();
    },
    
    applyFilter() {
      this.currentPage = 1;
      this.getAclAccessLogs();
    },

    clearFilter() {
      this.resetFilterState();
      this.reports = [];
      this.getAclAccessLogs();
    },

    resetFilterState() {
      this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
      this.endDate = moment().format('YYYY-MM-DD');
      this.searchUser = [];
      this.is_active = 'active';
      this.eventMode = 'all';
      this.activeBtn = null;
      this.currentPage = 1;
      this.perPage = 25;
    },

    updateQueryParams() {
      const query = this.getQueryParams();
      // Push the query parameters to the route
      this.routeQueryUpdate(query);
    },

    getQueryParams() {
      const queryParams = {
        startDate: this.startDate,
        endDate: this.endDate,
        searchUser: this.searchUser.join(",") || null,
        eventMode: this.eventMode,
        is_active: this.is_active,
        active: this.activeBtn,
        perPage: this.perPage,
        currentPage: this.currentPage,
      };

      // Filter out null or empty values from the query object
      return Object.keys(queryParams).reduce((acc, key) => {
        if (queryParams[key] || queryParams[key] === 0) acc[key] = queryParams[key];
        return acc;
      }, {});
    },

    async getAclAccessLogs() {
      this.loader = true;
      this.updateQueryParams();
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        start_date: this.startDate,
        end_date: this.endDate,
        emp_ids: this.searchUser,
        event_mode: this.eventMode === 'all' ? '' : this.eventMode,
      };

      this.payload = input;

      try {
        const response = await this.getHTTPPostResponse('acl-access-log', input, false);

        if (response && response.status === 200) {
          const { data } = response;
          this.totalCount = data.count || 0;
          this.reports = data.acl_access_logs || [];
        } else {
          this.reports = [];
          this.totalCount = 0;
        }
      } catch (error) {
        console.error('Error fetching ACL access logs:', error);
        this.reports = [];
        this.totalCount = 0;
      } finally {
        this.loader = false;
      }
    },
    
    back() {
      this.$router.back();
    },

    sortedEmpIdUser(userList) {
      const users = [...userList]; // Create a shallow copy to avoid modifying the original array
      users.sort((a, b) => {
        const nameA = `${a.name} ${a.last_name}`.toUpperCase();
        const nameB = `${b.name} ${b.last_name}`.toUpperCase();
        return nameA.localeCompare(nameB);
      });

      return users.map((element) => ({
        value: element.emp_id                     ,
        label: `${element.full_name ? element.full_name : element.name}`,
        emp_id: element.emp_id, // Include emp_id in the dropdown options
      }));
    },
  },
};
